import Vue from 'vue';

import RtHeader from '../packages/header/src/main';
import RtContent from '../packages/content/src/main';
import RtToolbar from '../packages/toolbar/src/main';
import RtQuery from '../packages/query/src/main';
import RtGrid from '../packages/grid/src/main';
import RtPicklist from '../packages/picklist/src/main';
import RtButton from '../packages/button/src/main';
import RtSection from '../packages/section/src/main';
import RtNav from '../packages/nav/src/nav';
import RtNavItem from '../packages/nav/src/nav-item';
//Lookup
import RtLookup from '../packages/lookup/src/lookup';
import RtLookupDialog from '../packages/lookup/src/lookup-dialog';
//Lookup-chooser
import JsLookup from '../packages/lookup-chooser/src/lookup-chooser'
import JsLookupDialog from '../packages/lookup-chooser/src/lookup-chooser-dialog'
//Excel导入
import RtExcelImportDialog from '../packages/excel-import/src/main';
//流程提交
import RtFlowSubmitDialog from '../packages/flow/src/submit-dialog';
//审批进度
import RtApprovalProgress from '../packages/approval/src/progress';
import RtApprovalProgressDialog from '../packages/approval/src/progress-dialog';
//最新审核意见
import JSLastApprovalMemo from "@/components/flow/LastApprovalMemo";
//附件
import RtAnnotation from '../packages/annotation/main';

const components = [
    RtHeader,
    RtContent,
    RtToolbar,
    RtQuery,
    RtGrid,
    RtPicklist,
    RtButton,
    RtSection,
    RtNav,
    RtNavItem,
    RtLookup,
    RtLookupDialog,
    JsLookup,
    JsLookupDialog,
    RtExcelImportDialog,
    RtFlowSubmitDialog,
    RtApprovalProgress,
    RtApprovalProgressDialog,
    RtAnnotation,
    JSLastApprovalMemo,
];

export default {
    install: function (Vue, opts) {
        components.map(function (component) {
            Vue.component(component.name, component);
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./packages/index.js
// module id = 703
// module chunks = 220